<template>
  <newsletter-component
    documents-name="Newsletters"
    :documents="newsletters" />
</template>

<script>
import NewsletterComponent from '../components/NewsletterComponent.vue'

export default {
  data: () => ({
    newsletters: []
  }),

  components: {
    NewsletterComponent
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/customDocumentsV2')
        .then(resp => {
          vm.newsletters = resp.data
          vm.$store.commit('loading', false)
        })
    })
  },
  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
